import type { RoomBuilderTool } from '@magicschool/supabase/types';
import { emptyToolCustomization } from 'features/rooms/types';
import { v4 as uuid } from 'uuid';
import { storage } from '@/features/storage';

export const createEmptyRoomTool = (tool: RoomBuilderTool) => {
  const initialGradeLevel = storage.getItem(`last-grade-level-selected`) || 'pre-k';
  const toolInfo = {
    tool: { slug: tool.toolSlug, id: tool.toolId, title: tool.title, description: tool.description },
    fields: tool.fields,
  };
  const tempToolCustomization = emptyToolCustomization(toolInfo, initialGradeLevel, 'room');

  // For a customization-flavored RoomBuilderTool, tool.jsonConfig is the full
  // ToolCustomizationJsonConfig persisted by the customization's owner. Spread it
  // wholesale on top of the empty defaults so every field (tool_title,
  // tool_description, customInstructions, voice, inputs) carries through. Merge
  // inputs so any *new* base fields added since the customization was saved still
  // get their defaults from the empty template.
  const customizationConfig = tool.toolCustomizationId ? tool.jsonConfig : undefined;

  const json_config = {
    ...tempToolCustomization.json_config,
    ...customizationConfig,
    tool_title: customizationConfig?.tool_title || tool.title || '',
    tool_description: customizationConfig?.tool_description || tool.description || '',
    inputs: {
      ...tempToolCustomization.json_config.inputs,
      ...(customizationConfig?.inputs ?? {}),
    },
  };

  return {
    toolCustomization: {
      ...tempToolCustomization,
      json_config,
      source_customization_id: tool.toolCustomizationId ?? null,
    },
    toolSlug: tool.toolSlug,
    toolUuid: tool.toolId,
    roomToolId: uuid(),
    toolIcon: tool.icon,
    toolIconName: tool.iconName ?? null,
    baseToolTitle: tool.title,
    roomToolFormId: uuid(),
    lastTouched: new Date().toISOString(),
  };
};
